import React, { useCallback } from 'react';
import AdvicesBlock from '../AdvicesBlock/AdvicesBlock';
import CustomButton from '../CustomButton/CustomButton';
import { useHolidaysTheme } from '../../themes/useTheme';
import './BottomMainBlock.css';
import domainRouter from '../../navigation/domainRouter';
import config from '../../core/config/config';

interface IProps {
  onActivateClick?: () => void;
  removeTitle?: boolean;
  buttonTitle?: string;
  downloadIcon?: boolean;
  firstImage?: string;
  firstText?: string;
  secondText?: string;
  mainScreen?: boolean;
  isCorp?: boolean
}

const BottomMainBlock: React.FC<IProps> = ({ onActivateClick, removeTitle, buttonTitle, downloadIcon, firstImage, firstText, secondText, mainScreen = true, isCorp = false }) => {
  const { isBlackFriday, isPink, styles } = useHolidaysTheme()

  const handleActivateClick = useCallback(() => {
    domainRouter.go(config.codeRoute)
  }, [])

  return (
    <div className="MainBottomBlock" style={{
      // zIndex: 0,
      backgroundColor: isBlackFriday ? '#EFECEC' : '#fff',
      // marginTop: 30,
      paddingBottom: 50
    }}>
      <a id="advices" className="Title">Как это работает?</a>
      <AdvicesBlock
        isCorp={isCorp}
        isBlackFriday={isBlackFriday}
        isPink={isPink}
      />
      <div className="BottomMainBlockButton">
        <CustomButton
          className={styles['CustomButton']}
          downloadIcon={downloadIcon}
          title={buttonTitle || 'Активировать промокод'}
          onClick={handleActivateClick}
        />
      </div>
    </div>
  );
}

export default BottomMainBlock;
